import { render } from "./ValidOtp.vue?vue&type=template&id=96451f88&scoped=true"
import script from "./ValidOtp.vue?vue&type=script&lang=js"
export * from "./ValidOtp.vue?vue&type=script&lang=js"

import "./ValidOtp.vue?vue&type=style&index=0&id=96451f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96451f88"]])

export default __exports__